<div class="pr-medium-y">
  <h2 [attr.id]="labelledBy" class="font-heading-2 nordic-blue-900-text">
    {{ 'MMB.apis.form.title' | finLocalization }}
  </h2>
  <p class="regular-type">{{ 'MMB.apis.form.description' | finLocalization }}</p>
</div>

<form
  [formGroup]="apisForm"
  [class.disabled]="apisForm.disabled"
  [finFormErrorFocus]="apisForm"
  class="mr-medium-b"
  (ngSubmit)="updateApis()"
>
  <fieldset
    *ngIf="requiredForms.includes(ApisPaxFormFields.passengerInformation)"
    class="pr-small bg-white border rounded-large mr-small-b"
  >
    <legend class="font-heading-3 nordic-blue-900-text float-left pr-small-b">
      {{ 'MMB.apis.passenger.passengerInformation' | finLocalization }}
    </legend>
    <div class="cf"></div>

    <fcom-text-input
      *ngFor="let inputName of ['lastName', 'firstName', 'middleName']"
      [attr.data-testid]="'form-field-' + inputName"
      class="block pr-xsmall-b"
      [translationPrefix]="'MMB.apis.form.' + inputName"
      [parentForm]="apisForm.get(ApisPaxFormFields.passengerInformation)"
      [controlName]="inputName"
      [required]="inputName !== 'middleName'"
      [displayMargin]="false"
    >
    </fcom-text-input>

    <fin-select-input
      data-testid="form-field-gender"
      class="block pr-xsmall-b"
      [controlName]="'gender'"
      [translationPrefix]="'MMB.apis.form.gender'"
      [parentForm]="apisForm.get(ApisPaxFormFields.passengerInformation)"
      [required]="true"
      [options]="genders$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>

    <fin-form-group
      class="block pr-xsmall-b"
      [group]="apisForm.get([ApisPaxFormFields.passengerInformation, 'birthDate'])"
      [translationPrefix]="'paxDetails.fields'"
      [groupTranslationPrefix]="'paxDetails.fields.birthDate'"
      [legend]="'paxDetails.dateOfBirthLabel' | finLocalization"
      [required]="true"
      [names]="['dateOfBirth', 'monthOfBirth', 'yearOfBirth']"
    >
      <div class="flex pr-xxsmall-t">
        <fin-select-input
          data-testid="form-field-dateOfBirth"
          class="flex-1 flex--basis0 mr-xsmall-r"
          [controlName]="'dateOfBirth'"
          [translationPrefix]="'paxDetails.fields.dateOfBirth'"
          [parentForm]="apisForm.get([ApisPaxFormFields.passengerInformation, 'birthDate'])"
          [options]="availableDays$ | async"
          [displayMargin]="false"
        >
        </fin-select-input>

        <fin-select-input
          data-testid="form-field-monthOfBirth"
          class="flex-1 flex--basis0 mr-xsmall-r"
          [controlName]="'monthOfBirth'"
          [translationPrefix]="'paxDetails.fields.monthOfBirth'"
          [parentForm]="apisForm.get([ApisPaxFormFields.passengerInformation, 'birthDate'])"
          [options]="availableMonths$ | async"
          [displayMargin]="false"
        >
        </fin-select-input>

        <fin-select-input
          data-testid="form-field-yearOfBirth"
          class="flex-1 flex--basis0"
          [controlName]="'yearOfBirth'"
          [translationPrefix]="'paxDetails.fields.yearOfBirth'"
          [parentForm]="apisForm.get([ApisPaxFormFields.passengerInformation, 'birthDate'])"
          [options]="availableYears$ | async"
          [displayMargin]="false"
        >
        </fin-select-input>
      </div>
    </fin-form-group>
  </fieldset>

  <fieldset
    *ngIf="requiredForms.includes(ApisPaxFormFields.travelDocument)"
    class="pr-small bg-white border rounded-large mr-small-b"
  >
    <legend class="font-heading-3 nordic-blue-900-text float-left pr-small-b">
      {{ 'MMB.apis.passenger.travelDocument' | finLocalization }}
    </legend>
    <div class="cf"></div>

    <fcom-text-input
      data-testid="form-field-documentNumber"
      class="block pr-xsmall-b"
      [translationPrefix]="'MMB.apis.form.documentNumber'"
      [parentForm]="apisForm.get(ApisPaxFormFields.travelDocument)"
      [controlName]="'documentNumber'"
      [required]="false"
      [displayMargin]="false"
    >
    </fcom-text-input>

    <fin-select-input
      data-testid="form-field-issuingCountry"
      class="block pr-xsmall-b"
      [controlName]="'issuingCountry'"
      [translationPrefix]="'MMB.apis.form.issuingCountry'"
      [parentForm]="apisForm.get(ApisPaxFormFields.travelDocument)"
      [required]="false"
      [options]="countryCodes$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>

    <fin-select-input
      data-testid="form-field-nationality"
      class="block pr-xsmall-b"
      [controlName]="'nationality'"
      [translationPrefix]="'MMB.apis.form.nationality'"
      [parentForm]="apisForm.get(ApisPaxFormFields.travelDocument)"
      [required]="false"
      [options]="nationalities$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>

    <fin-form-group
      class="block pr-xsmall-b"
      [group]="apisForm.get([ApisPaxFormFields.travelDocument, 'validityDate'])"
      [translationPrefix]="'MMB.apis.form'"
      [groupTranslationPrefix]="'MMB.apis.form.validityDate'"
      [legend]="'MMB.apis.form.travelDocumentExpiryLabel' | finLocalization"
      [required]="false"
      [names]="['day', 'month', 'year']"
    >
      <div class="flex pr-xxsmall-t">
        <fin-select-input
          data-testid="form-field-day"
          class="flex-1 flex--basis0 mr-xsmall-r"
          [controlName]="'day'"
          [translationPrefix]="'MMB.apis.form.day'"
          [parentForm]="apisForm.get([ApisPaxFormFields.travelDocument, 'validityDate'])"
          [options]="validityDays$ | async"
          [displayMargin]="false"
        >
        </fin-select-input>

        <fin-select-input
          data-testid="form-field-month"
          class="flex-1 flex--basis0 mr-xsmall-r"
          [controlName]="'month'"
          [translationPrefix]="'MMB.apis.form.month'"
          [parentForm]="apisForm.get([ApisPaxFormFields.travelDocument, 'validityDate'])"
          [options]="availableMonths$ | async"
          [displayMargin]="false"
        >
        </fin-select-input>

        <fin-select-input
          data-testid="form-field-year"
          class="flex-1 flex--basis0"
          [controlName]="'year'"
          [translationPrefix]="'MMB.apis.form.year'"
          [parentForm]="apisForm.get([ApisPaxFormFields.travelDocument, 'validityDate'])"
          [options]="validityYears$ | async"
          [displayMargin]="false"
        >
        </fin-select-input>
      </div>
    </fin-form-group>
  </fieldset>

  <fieldset
    *ngIf="requiredForms.includes(ApisPaxFormFields.residencyAddress)"
    class="pr-small bg-white border rounded-large mr-small-b"
  >
    <legend class="font-heading-3 nordic-blue-900-text float-left pr-small-b">
      {{ 'MMB.apis.passenger.residencyAddress' | finLocalization }}
    </legend>
    <div class="cf"></div>

    <fcom-text-input
      data-testid="form-field-city"
      class="block pr-xsmall-b"
      [translationPrefix]="'MMB.apis.form.city'"
      [parentForm]="apisForm.get(ApisPaxFormFields.residencyAddress)"
      [controlName]="'city'"
      [required]="false"
      [displayMargin]="false"
    >
    </fcom-text-input>

    <fin-select-input
      data-testid="form-field-country"
      class="block pr-xsmall-b"
      [controlName]="'country'"
      [translationPrefix]="'MMB.apis.form.country'"
      [parentForm]="apisForm.get(ApisPaxFormFields.residencyAddress)"
      [required]="false"
      [options]="countryCodes$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>
  </fieldset>

  <fieldset
    *ngIf="requiredForms.includes(ApisPaxFormFields.destinationAddress)"
    class="pr-small bg-white border rounded-large mr-small-b"
  >
    <legend
      class="font-heading-3 nordic-blue-900-text float-left"
      [ngClass]="{ 'pr-small-b': addressOptions.length === 0, 'pr-xsmall-b': addressOptions.length > 0 }"
    >
      {{ 'MMB.apis.passenger.destinationAddress' | finLocalization }}
    </legend>
    <div class="cf"></div>

    <ng-container *ngIf="addressOptions.length > 0">
      <p class="pr-small-b" data-testid="use-same-address-description">
        {{ 'MMB.apis.form.useSameAddress.description' | finLocalization }}
      </p>

      <fin-select-input
        data-testid="form-field-useSameAddress"
        class="block pr-xsmall-b"
        [controlName]="'useSameAddress'"
        [translationPrefix]="'MMB.apis.form.useSameAddress'"
        [parentForm]="addressGroup"
        [required]="false"
        [options]="addressOptions"
        [displayMargin]="false"
      >
      </fin-select-input>
    </ng-container>

    <fcom-text-input
      data-testid="form-field-address"
      class="block pr-xsmall-b"
      [translationPrefix]="'MMB.apis.form.address'"
      [parentForm]="apisForm.get(ApisPaxFormFields.destinationAddress)"
      [controlName]="'address'"
      [required]="false"
      [displayMargin]="false"
    >
    </fcom-text-input>
    <fcom-text-input
      data-testid="form-field-destinationCity"
      class="block pr-xsmall-b"
      [translationPrefix]="'MMB.apis.form.destinationCity'"
      [parentForm]="apisForm.get(ApisPaxFormFields.destinationAddress)"
      [controlName]="'destinationCity'"
      [required]="false"
      [displayMargin]="false"
    >
    </fcom-text-input>
    <fin-select-input
      data-testid="form-field-destinationCountry"
      class="block pr-xsmall-b"
      [controlName]="'destinationCountry'"
      [translationPrefix]="'MMB.apis.form.destinationCountry'"
      [parentForm]="apisForm.get(ApisPaxFormFields.destinationAddress)"
      [required]="false"
      [options]="countryCodes$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>

    <ng-container *ngIf="apisForm.get(['destinationAddress', 'destinationCountry']).value === 'US'">
      <fin-select-input
        data-testid="form-field-state"
        class="block pr-xsmall-b"
        [controlName]="'state'"
        [translationPrefix]="'MMB.apis.form.state'"
        [parentForm]="apisForm.get(ApisPaxFormFields.destinationAddress)"
        [required]="false"
        [options]="countryRegions$ | async"
        [displayMargin]="false"
      >
      </fin-select-input>
    </ng-container>

    <fcom-text-input
      data-testid="form-field-zipCode"
      class="block pr-xsmall-b"
      [translationPrefix]="'MMB.apis.form.zipCode'"
      [parentForm]="apisForm.get(ApisPaxFormFields.destinationAddress)"
      [controlName]="'zipCode'"
      [required]="false"
      [displayMargin]="false"
    >
    </fcom-text-input>
  </fieldset>

  <fin-input-checkbox
    data-testid="form-field-confirm"
    [group]="apisForm"
    [modelName]="'confirm'"
    [name]="'confirm'"
    [hideError]="true"
    [containerClass]="'flex'"
    [labelClass]="'font-body-1 inline-block pr-xxsmall-l'"
    [required]="true"
    [translationPrefix]="'MMB.apis.form.confirm'"
  ></fin-input-checkbox>

  <div class="pr-small-t align-right">
    <fcom-button
      data-testid="cancel-apis-button"
      [size]="ButtonSize.MEDIUM"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [text]="'actions.cancel' | finLocalization"
      (clickBtn)="emitClose()"
    ></fcom-button>
    <fcom-button
      class="pr-xsmall-l"
      data-testid="submit-apis-button"
      [loading]="updatingApis$ | async"
      [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
      [icon]="(updatingApis$ | async) ? { name: SvgLibraryIcon.TRANSFER_LOADER, position: IconPosition.RIGHT } : null"
      [type]="ButtonType.SUBMIT"
      [size]="ButtonSize.MEDIUM"
      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      [text]="'MMB.labels.saveDetails' | finLocalization"
    ></fcom-button>
  </div>
</form>
